import awsLogo from "@assets/Logos/AWS.svg";
import azureLogo from "@assets/Logos/AzureLogo.svg";
import gcpLogo from "@assets/Logos/GPCLogo.svg";
import oracleLogo from "@assets/Logos/OracleLogo.svg";
import { CloudKey, resolveCloudKey } from "./cloudProviderLinks";

const LOGO_BY_CLOUD: Readonly<Record<CloudKey, string>> = {
  aws: awsLogo,
  azure: azureLogo,
  gcp: gcpLogo,
  oci: oracleLogo,
};

/**
 * The vendor's logo for a `cloud` value, or `null` for a cloud we hold no logo
 * for (SAP, Salesforce, ...): the caller draws its generic cloud instead of a
 * guess.
 */
export function resolveCloudProviderLogo(cloud: string | null | undefined): string | null {
  const key = resolveCloudKey(cloud);
  return key ? LOGO_BY_CLOUD[key] : null;
}
